import React from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../i18n/LanguageContext";
import { ArrowLeft } from "lucide-react";

const renderSection = (section, idx) => (
  <section
    key={idx}
    data-testid={`legal-section-${idx}`}
    className="mt-10 first:mt-0"
  >
    <h2 className="text-xl md:text-2xl font-semibold text-[#111] mb-4" style={{ fontFamily: "Georgia, serif" }}>
      {section.heading}
    </h2>

    {section.lines && (
      <div className="space-y-1 text-base text-neutral-700">
        {section.lines.map((line, i) => (
          <p key={i}>{line}</p>
        ))}
      </div>
    )}

    {section.paragraphs && (
      <div className="space-y-4 text-base text-neutral-700 leading-relaxed">
        {section.paragraphs.map((p, i) => (
          <p key={i}>{p}</p>
        ))}
      </div>
    )}

    {section.bullets && (
      <ul className="mt-4 list-disc pl-5 space-y-1 text-base text-neutral-700">
        {section.bullets.map((b, i) => (
          <li key={i}>{b}</li>
        ))}
      </ul>
    )}

    {section.paragraphsAfter && (
      <div className="mt-4 space-y-4 text-base text-neutral-700 leading-relaxed">
        {section.paragraphsAfter.map((p, i) => (
          <p key={i}>{p}</p>
        ))}
      </div>
    )}
  </section>
);

const LegalPage = ({ kind = "impressum" }) => {
  const { t } = useLanguage();
  const content = kind === "impressum" ? t.legal.impressum : t.legal.privacy;

  return (
    <div data-testid={`legal-${kind}`} className="min-h-screen bg-[#FDFDFD] text-[#111]">
      <header className="px-6 md:px-12 lg:px-20 py-6 flex items-center justify-between border-b border-neutral-200">
        <Link
          to="/"
          data-testid="legal-back-link"
          className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.24em] opacity-70 hover:opacity-100"
        >
          <ArrowLeft size={14} /> {t.nav.backHome}
        </Link>
        <span className="entry-display text-lg">Enrico Müller</span>
      </header>

      <main className="px-6 md:px-12 lg:px-20 py-16 md:py-24 max-w-3xl">
        <span className="eyebrow text-neutral-500">Legal</span>
        <h1 className="mt-5 text-4xl md:text-5xl entry-display">{content.title}</h1>
        <p className="mt-4 text-sm text-neutral-500">{t.legal.lastUpdated}</p>

        {content.intro && (
          <p className="mt-8 text-base md:text-lg text-neutral-700 leading-relaxed">
            {content.intro}
          </p>
        )}

        <div className="mt-10 border-t border-neutral-200 pt-8">
          {content.sections.map(renderSection)}
        </div>

        <div className="mt-16 border-t border-neutral-200 pt-8 text-sm text-neutral-500 space-y-1">
          <p>Enrico Müller · Personal Coach</p>
          <p>Rosenstraße 2 · 97499 Geroldshofen · Deutschland</p>
          <p>info@green-horizon-life.com</p>
        </div>
      </main>
    </div>
  );
};

export default LegalPage;
